import associateEditors from "./associateEditors";
import associateEditor from "./associateeditor";
import editor from "./editor";
import revNumByAssociateEditorList from "./rev-num-by-associate-editor";

export default [...associateEditors, ...associateEditor, ...editor, ...revNumByAssociateEditorList];